import { SVGProps } from 'react'

const LearningPathIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="147"
      height="146"
      viewBox="0 0 157 156"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_9249_41118)">
        <path
          d="M54.7549 110.5H43.2109C27.0844 110.5 13.9609 97.3765 13.9609 81.25C13.9609 65.1235 27.0844 52 43.2109 52H83.4654C85.6624 56.641 88.6264 61.009 92.4679 64.8505L99.2669 71.5H43.2109C37.8354 71.5 33.4609 75.8745 33.4609 81.25C33.4609 86.6255 37.8354 91 43.2109 91H54.7549C53.6629 94.0615 52.9609 97.3115 52.9609 100.75C52.9609 104.188 53.6629 107.438 54.7549 110.5ZM127.711 91H109.667C110.759 94.0615 111.461 97.3115 111.461 100.75C111.461 104.188 110.759 107.438 109.667 110.5H127.711C133.093 110.5 137.461 114.868 137.461 120.25C137.461 125.632 133.093 130 127.711 130H44.6669C45.7589 133.062 46.4609 136.312 46.4609 139.75C46.4609 143.188 45.7589 146.438 44.6669 149.5H127.711C143.863 149.5 156.961 136.402 156.961 120.25C156.961 104.097 143.863 91 127.711 91ZM17.2109 123.5C8.23444 123.5 0.960938 130.773 0.960938 139.75C0.960938 148.727 8.23444 156 17.2109 156C26.1874 156 33.4609 148.727 33.4609 139.75C33.4609 130.773 26.1874 123.5 17.2109 123.5ZM65.9609 100.75C65.9609 109.727 73.2344 117 82.2109 117C91.1874 117 98.4609 109.727 98.4609 100.75C98.4609 91.7735 91.1874 84.5 82.2109 84.5C73.2344 84.5 65.9609 91.7735 65.9609 100.75Z"
          fill="#7181FF"
        />
        <path
          d="M156 29.1151V59.8351C156 60.5424 155.719 61.2206 155.219 61.7207C154.719 62.2208 154.04 62.5018 153.333 62.5018C152.626 62.5018 151.948 62.2208 151.447 61.7207C150.947 61.2206 150.666 60.5424 150.666 59.8351V37.8405L130.933 47.2698C128.852 48.4979 126.477 49.1376 124.061 49.1205C121.527 49.1244 119.04 48.4435 116.861 47.1498L97.1811 37.7818C95.6341 36.9499 94.3379 35.7192 93.427 34.2174C92.5161 32.7156 92.0237 30.9974 92.0008 29.2411C91.978 27.4848 92.4255 25.7543 93.297 24.2293C94.1686 22.7043 95.4323 21.4403 96.9571 20.5684C97.0291 20.5258 97.1064 20.4858 97.1811 20.4485L117.066 10.9604C119.213 9.72755 121.65 9.08879 124.125 9.10988C126.601 9.13097 129.026 9.81115 131.152 11.0804L150.818 20.4485C152.37 21.3071 153.667 22.5612 154.577 24.0835C155.487 25.6057 155.978 27.3417 156 29.1151ZM124.058 54.4484C120.647 54.456 117.293 53.5618 114.338 51.8564L102.666 46.2858V53.4858C102.668 56.3325 103.579 59.1042 105.268 61.3964C106.956 63.6885 109.332 65.3811 112.05 66.2271C115.934 67.3422 119.96 67.8839 124 67.8351C128.04 67.8804 132.066 67.3351 135.949 66.2164C138.667 65.3704 141.044 63.6779 142.732 61.3857C144.42 59.0936 145.332 56.3218 145.333 53.4751V46.2991L133.442 51.9791C130.588 53.6189 127.35 54.4728 124.058 54.4538V54.4484Z"
          fill="#7181FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_9249_41118">
          <rect
            width="156"
            height="156"
            fill="white"
            transform="translate(0.960938)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default LearningPathIcon
